export default function userReducers (state='', action)	 {
	switch (action.type) {
		case 'userData':
			return action.payload;
		case 'default':
			return state;
		case 'Error':
			return action.payload;
		default:
			return state;
	}
}